<template>
  <!--
    Replaces inline PDF/video preview logic previously duplicated in:
    - learningCourses/components/Screen.vue
    - course/components/Screen.vue
    - admin/CustomizePreviewPop.vue
  -->
  <div>
    <div v-if="docType === 'video' && videoUrl">
      <video
        :id="videoId"
        width="100%"
        :height="videoHeight"
        controls
        :autoplay="autoplay"
        controlsList="nodownload"
        :class="videoClass"
        :src="videoUrl"
        @pause="$emit('pause', $event)"
      >
        <source :src="videoUrl" :type="videoMimeType" />
        Your browser does not support the video tag.
      </video>
      <p v-if="isNonMp4Video && showVideoFormatHint" class="text-sm text-muted mt-2 text-center">
        If playback fails, download the video using the topic link or re-upload
        as MP4.
      </p>
    </div>

    <div v-else-if="isDocumentPreview">
      <iframe
        v-if="documentPreview.previewUrl"
        class="screenht450 w-full -mt-4"
        :src="documentPreview.previewUrl"
        frameborder="0"
        :height="iframeHeight"
        width="100%"
      ></iframe>
      <div v-if="documentPreview.kind === 'word'" class="text-center mt-3">
        <a
          :href="documentPreview.downloadUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="text-primary underline"
        >
          Download document
        </a>
      </div>
      <p
        v-if="documentPreview.kind === 'word'"
        class="text-sm text-muted mt-2 text-center"
      >
        If preview does not load, use the download link below.
      </p>
    </div>
  </div>
</template>

<script>
import {
  ALLOWED_DOCUMENT_EXTENSIONS,
  buildDocumentPreview,
  buildMediaUrl,
  getFileExtension,
  getImageBaseUrl,
  getVideoMimeType,
  isDocumentDocType,
} from "@/utils/mediaUrl";

export default {
  props: {
    docPath: {
      type: String,
      default: "",
    },
    docType: {
      type: String,
      default: "",
    },
    imageUrl: {
      type: String,
      default: "",
    },
    videoId: {
      type: String,
      default: "",
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    iframeHeight: {
      type: [String, Number],
      default: 600,
    },
    videoHeight: {
      type: String,
      default: "100%",
    },
    videoClass: {
      type: String,
      default: "",
    },
    showVideoFormatHint: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    baseImageUrl() {
      return getImageBaseUrl(this.imageUrl || this.$imageURL);
    },
    videoUrl() {
      return buildMediaUrl(this.docPath, this.baseImageUrl);
    },
    videoMimeType() {
      return getVideoMimeType(this.docPath);
    },
    isDocumentPreview() {
      if (this.docType === "video") return false;
      if (isDocumentDocType(this.docType)) return true;

      return ALLOWED_DOCUMENT_EXTENSIONS.includes(
        getFileExtension(this.docPath)
      );
    },
    documentPreview() {
      return buildDocumentPreview(
        this.docPath,
        this.baseImageUrl,
        this.docType
      );
    },
    isNonMp4Video() {
      const ext = getFileExtension(this.docPath);
      return ext && ext !== "mp4";
    },
  },
};
</script>
